<div class="invoice-box"  id="exportpdf">

    <h3 class="invoice-title">
      Invoice Paket Subscription Cepetdapet
    </h3>


    <div class="row mb-4">
        <div class="col-md-2">
            <div class="logo-box">LOGO</div>        
        </div>
        <div class="col-md-5">
            <h5 class="fw-bold mb-1">{{companyName}}</h5>
            <p class="mb-1">{{billingDetail?.billingAddress}}</p>
            <p class="mb-1">{{billingDetail?.billingProvince}}</p>
            <p class="mb-1">{{billingDetail?.billingCity}}</p>
            <p class="mb-1">{{billingDetail?.billingCountry}} {{billingDetail?.billingPostalCode}}</p>
        </div>
        <div class="col-md-5">
            <p class="mb-1"><strong>Nomor Telepon:</strong> {{billingDetail?.billingPhone}}</p>
            <p class="mb-1"><strong>Email:</strong> {{billingDetail?.billingEmail}}</p>
            <p class="mb-1"><strong>NPWP:</strong> {{billingDetail?.billingTaxId}}</p>
        </div>


    </div>

    <div class="row mb-4">
        <div class="col-md-6">
            <p><strong>No. Invoice:</strong> {{proformaInvoiceDetail?.proformaInvoiceNo}}</p>
            <p><strong>ID Pelanggan:</strong> #{{formatDisplayId(companyId)}}</p>
        </div>
        <div class="col-md-6 text-md-end">
            <p><strong>Tanggal:</strong> {{proformaInvoiceDetail?.proformaInvoiceDate | date:'d MMM y'}}</p>
        </div>
    </div>

    <div class="table-responsive mb-4">
        <table class="table table-bordered" *ngIf="billingDetail?.billingItem ">
            <thead>
                <tr>
                    <th style="width:5%">No</th>
                    <th style="width:20%">Produk</th>
                    <!-- <th style="width:20%">Masa Berlaku</th> -->
                    <th style="width:30%">Deskripsi</th>
                    <th style="width:5%">Jml</th>
                    <th style="width:20%">Harga</th>
                    <th style="width:20%">Total</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of billingDetail?.billingItem; let i = index">










                    <td>{{ i + 1 }}</td>
                    <td>{{ item?.offeringLabel }}</td>
                    <!-- <td>10 Jun 2025 - 10 Jul 2025</td> -->
                    <td>
                                            <div class="mb-0" *ngIf="item?.subscriptionFeatures && item.subscriptionFeatures.length > 0">
                                              <ul class="mb-0">
                                                <li *ngFor="let feature of item?.subscriptionFeatures">
                                                {{ feature }}
                                                </li>
                                              </ul>    
                                              
                                            </div>
                    </td>
                    <td class="text-end">{{ item?.purchasedQty }}</td>
                    <td class="text-end">IDR {{ item?.price | number:'1.0-0' }}</td>
                    <td class="text-end">IDR {{ ((item?.price || 0) * (item?.purchasedQty || 0)) | number:'1.0-0' }}</td>
                </tr>

 
            </tbody>
        </table>
    </div>

    <!-- <div class="dashed-box mb-4">
        <div class="row">
            <div class="col-md-4"><strong>No. Proforma Invoice</strong></div>
            <div class="col-md-8">#{{proformaInvoiceDetail?.proformaInvoiceNo}}</div>

            <div class="col-md-4"><strong>Metode Pembayaran</strong></div>
            <div class="col-md-8">Transfer Bank BCA</div>

            <div class="col-md-4"><strong>Nomor Rekening</strong></div>
            <div class="col-md-8">1234 5678 90 (PT Cepetdapet Company)</div>
        </div>
    </div> -->

    <div class="row"> <!--  justify-content-end -->

        <div class="col-md-8">

          <div class="dashed-box mb-4">
              <div class="row">
                  <div class="col-md-4"><strong>No. Proforma Invoice</strong></div>
                  <div class="col-md-8">{{proformaInvoiceDetail?.proformaInvoiceNo}}</div>

                  <div class="col-md-4"><strong>Metode Pembayaran</strong></div>
                  <div class="col-md-8">Transfer Bank BCA</div>

                  <div class="col-md-4"><strong>Nomor Rekening</strong></div>
                  <div class="col-md-8">1234 5678 90 (PT Cepetdapet Company)</div>
              </div>
          </div>

        </div>
      
        <div class="col-md-4">
            <div class="summary-box">
                <div class="d-flex justify-content-between total-row">
                    <span>Subtotal</span>
                    <span>IDR {{ getTotalPrice() | number:'1.0-0' }}</span>
                </div>
                <div class="d-flex justify-content-between total-row" *ngIf="billingDetail?.billingTax">
                    <span>Pajak</span>
                    <span>IDR {{ billingDetail?.billingTax | number:'1.0-0' }}</span>
                </div>
                <!-- <div class="d-flex justify-content-between total-row">
                    <span>Voucher</span>
                    <span>(- IDR 200,000)</span>
                </div> -->
                <hr>
                <div class="d-flex justify-content-between total-final">
                    <span>Total</span>
                    <span>IDR {{ getGrandTotal() | number:'1.0-0' }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Payment History Section -->
    <div style="margin-top: 40px; border-top: 1px solid #ddd; padding-top: 20px;">
        <h4 style="margin-bottom: 20px; font-weight: bold;">Riwayat Pembayaran</h4>

        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
            <thead>
                <tr style="background-color: #333; color: white;">
                    <th style="padding: 12px; text-align: left; font-weight: bold;">Tanggal</th>
                    <th style="padding: 12px; text-align: left; font-weight: bold;">Bukti Pembayaran</th>
                    <th style="padding: 12px; text-align: right; font-weight: bold;">Total</th>
                </tr>
            </thead>
            <tbody>
                <!-- <tr style="border-bottom: 1px solid #ddd;">
                    <td colspan="3" style="padding: 20px; text-align: center; color: #999; font-style: italic;">
                        Lihat pada lembar lampiran riwayat bukti pembayaran
                    </td>
                </tr> -->
                <tr *ngFor="let payment of proformaInvoiceDetail?.paymentImageUrl" style="border-bottom: 1px solid #ddd;">
                    <td style="padding: 12px;">{{ payment.paymentDate | date: 'dd MMM yyyy HH:mm' }}</td>
                    <td style="padding: 12px;">
                        <img [src]="payment.imageUrl" (error)="onImageLoadError($event)" style="max-width: 100px; max-height: 100px;" crossorigin="anonymous">
                    </td>
                    <td style="padding: 12px; text-align: right;">IDR {{payment.value | number}}</td>
                </tr>
            </tbody>
        </table>

        <!-- <p style="margin-top: 30px; font-size: 12px; color: #666;">
            Dokumen ini diterbitkan oleh (Nama Admin Billing) pada tanggal {{ 'now' | date:'dd/MM/yyyy HH.mm' }}
        </p> -->
    </div>

</div>

